/* oxlint-disable react/no-danger */

import { clsx } from 'clsx';
import { type FC } from 'react';

import { AdLabel } from 'shared/components/AdLabel';
import { MortgageAnnotations } from 'shared/components/MortgageAnnotations';
import { Ticker } from 'shared/components/Ticker';
import { toCssImageUrl } from 'shared/utils/toCssImageUrl';

import { type TGetMainpageBrandCompleteContextResult } from '../../utils/getMainpageBrandCompleteContext';

import styles from './MainpageBrandMobile.css';

export type TMainpageBrandMobileProps = {
  completeContext: TGetMainpageBrandCompleteContextResult;
};

export const MainpageBrandMobile: FC<TMainpageBrandMobileProps> = ({
  completeContext: {
    url,
    bgImageUrl,
    logoImageUrl,
    label,
    note,
    sanitizedActionText,
    mortgageWarning,
    mortgageTermsWarning,
    sizes,
  },
}) => {
  const withMortgageAnnotations = !!(mortgageWarning || mortgageTermsWarning);

  return (
    <a
      className={clsx(styles['container'], !mortgageTermsWarning && styles['container--without-terms'])}
      href={url}
      target="_blank"
      rel="noopener noreferrer nofollow"
      style={{ ...sizes, backgroundImage: toCssImageUrl(bgImageUrl) }}
      data-testid="mainpage-brand-mobile"
    >
      <div className={styles['main']}>
        <div className={styles['content']}>
          {!!logoImageUrl && (
            <span className={styles['logo']}>
              <img className={styles['logo-image']} src={logoImageUrl} alt="logo" />
            </span>
          )}
          {!!sanitizedActionText && (
            <span className={styles['content-text']} dangerouslySetInnerHTML={{ __html: sanitizedActionText }} />
          )}
        </div>

        {!!label && (
          <span className={styles['label']}>
            <AdLabel theme="deprecated" label={label} />
          </span>
        )}
      </div>

      {(!!note || withMortgageAnnotations) && (
        <div className={styles['disclaimers']}>
          {!!note && (
            <div className={styles['disclaimer']} data-testid="disclaimer">
              <Ticker text={note} theme="light" />
            </div>
          )}

          {withMortgageAnnotations && (
            <div className={styles['mortgage-disclaimer']} data-testid="mortgage-disclaimer">
              <MortgageAnnotations
                splitMortgageTermsWarning
                height={sizes.height}
                mortgageWarning={mortgageWarning}
                mortgageTermsWarning={mortgageTermsWarning}
              />
            </div>
          )}
        </div>
      )}
    </a>
  );
};
